import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import { LanguageProvider } from './i18n/language-context';
import './i18n/i18n';
import { AppRoutes } from './routes/app-routes';

const queryClient = new QueryClient();

export default function App() {
  return (
    <BrowserRouter>
      <NuqsAdapter>
        <QueryClientProvider client={queryClient}>
          <LanguageProvider defaultLanguage="en-US" defaultModules={['common', 'auth']}>
            <AppRoutes />
          </LanguageProvider>
        </QueryClientProvider>
      </NuqsAdapter>
    </BrowserRouter>
  );
}
